angular.module 'zc.master.zcliteInvoices'

# TODO: this is copypaste from zcs! remove when doing webpack
.factory 'ZcsInvoice', ($q, FacadeV2) ->
  class ZcsInvoice
    @all: (apikey) ->
      FacadeV2.request "/apikeys/#{apikey}/zcs_invoices/"
      .then (res) ->
        res.data

    @find: (apikey, term) ->
      FacadeV2.request "/apikeys/#{apikey}/zcs_invoices/#{term}", {}
      .then (res) ->
        res.data

    @generateDemoData: ->
      new_client: true
      consumption_tax: 680
      discount: 2
      fee_rate: 0.05
      invoice_price: 9180
      invoice_price_tax_excluded: 8500
      max_invoice: 30000
      monthly_total_conversion: 3924191
      total_campaign_price: 170057
      details: [
        _id: '1234'
        conversion_count: 8
        device: 'pc'
        invoice: 5846
        total: 116922
      ,
        _id: '1234'
        conversion_count: 6
        device: 'other'
        invoice: 2656
        total: 53135
      ]



// WEBPACK FOOTER //
// ./src/master_admin_modules/master.zclite_invoices/zcs_invoice.service.coffee